import { Button, MenuItem, SelectChangeEvent } from "@mui/material";
import { Select } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import React, { useContext, useEffect, useMemo, Suspense, useRef } from "react";
import { CustomDisclaimerDialogPropsType } from "../../../../../../../types/dialogProps.types";
import CustomEnrollmentDisclaimerDialog from "../../../../../../shared/dialogs/customEnrollmentDisclaimerDialog/customEnrollmentDisclaimerDialog";
import {
	AuthContext,
	EnrollmentContext,
	GroupOwnerContext,
	PaycheckContext,
	ThemeContext
} from "../../../../../../../contexts";
import { LazyCustomFormDialog, LazyPlanActions, VEBDisclaimer } from "../../../../../../shared";
import { Checkbox } from "@mui/material";
import { useState } from "react";
import { useCallback } from "react";
import "./macPlan.css";
import { PaycheckFrequency, VEBPlan } from "../../../../../../../types/plan.types";
import { MacBenefitAmount, MacPlanDetails, MacCoverage } from "../../../../../../../types/plan.types";
import { Member } from "../../../../../../../types/employee.types";
import {
	generateActivateVEBEnrollmentPayload,
	generateMaxCareDentalWaiveEnrollmentPayload
} from "../../../../../../../utils/commonFunctions/VEBEnrollment/enrollment";
import { getMaxCareDentailEligibleDependents } from "../../../../../../../utils/commonFunctions/VEBEnrollment/eligibleDependents";
import { CustomInput, CustomSelectInput } from "../../../../../../shared/CustomInput";
import { GroupOwner } from "../../../../../../../types/groupOwner.types";
import { VEBPlanFormProps } from "../../../../../../../types/components/enrollmentProps.types";
import VEBPlanHeader from "../../../../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../../../../utils/commonFunctions/date";
import { VEB_PLAN_NAME, VEB_PLAN_NAMES } from "../../../../../../../constants/plan";
import { VEBToGeneralCoverageCodeType, VEB_TO_GENERAL_COVERAGE_CODE } from "../../../../../../../constants/coverage";
import { VEBEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { dollarize } from "../../../../../../../utils/commonFunctions/dollarize";
import { api } from "../../../../../../../utils/api";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import { trackPromise } from "react-promise-tracker";
import { EligiblityDialogProps } from "../../../../../../../types/components/eligiblityDialogProps.types";
import EligiblityDialog from "../../../../eligiblityDialogs/EligiblityDialog";
import { VEBPlanCodes2024 } from "../../../../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../../../../constants/VEBYearlyOpenAndCurrentDate";
import ExistsDependentModelVEB from "../../../../../../shared/existsMemberModel/ExistsDependentModelVEB";

const MacPlanForm = ({ getVEBEnrollmentInitData, VEBOpenEnrollment, dependents }: VEBPlanFormProps): JSX.Element => {
	const [writingNumber, setWritingNumber] = useState(1408);
	const [waiveReason, setWaiveReason] = useState("");
	const [emailDisclaimer, setEmailDisclaimer] = useState("");
	const [hasReadTC, setHasReadTC] = useState(false);
	const [isDependentExistsModelOpen, setIsDependentExistsModelOpen] = useState(false);
	const [existsDependentData, setExistsDependentData] = useState<any>(null);
	const isDependentExistsModelOpenRef = useRef(false);
	const [isActivelyWorking, setIsActivelyWorking] = useState(false);
	const [dentalPlan, setDentalPlan] = useState<VEBPlan>({
		_id: "",
		plan_name: "",
		plan_code: "",
		start_date: null,
		end_date: null,
		status: ""
	});
	const [macPlanInputs, setMacPlanInputs] = useState<{
		coverage: null | string;
		benefit_amount: null | number;
		primium: number;
	}>({
		coverage: null,
		benefit_amount: null,
		primium: 0
	});
	const [macPlan, setMacPlan] = useState<MacPlanDetails>({
		coverage: [],
		benefit_amount: [3000, 1500, 5000],
		premium_amount: {
			"Employee Only": {
				3000: {
					WEEKLY: 11.54,
					MONTHLY: 49.99
				},
				1500: {
					WEEKLY: 9.92,
					MONTHLY: 42.99
				},
				5000: {
					WEEKLY: 13.84,
					MONTHLY: 59.99
				}
			},
			"Employee & Spouse": {
				3000: {
					WEEKLY: 17.31,
					MONTHLY: 74.99
				},
				1500: {
					WEEKLY: 16.15,
					MONTHLY: 69.99
				},
				5000: {
					WEEKLY: 19.61,
					MONTHLY: 84.99
				}
			},
			"Employee & Children": {
				3000: {
					WEEKLY: 20.77,
					MONTHLY: 89.99
				},
				1500: {
					WEEKLY: 18.46,
					MONTHLY: 79.99
				},
				5000: {
					WEEKLY: 23.07,
					MONTHLY: 99.99
				}
			},
			"Employee & Family": {
				3000: {
					WEEKLY: 26.54,
					MONTHLY: 114.99
				},
				1500: {
					WEEKLY: 23.07,
					MONTHLY: 99.99
				},
				5000: {
					WEEKLY: 30.0,
					MONTHLY: 129.99
				}
			}
		}
	});
	const [enrollmentDisclaimerDialogProps, setEnrollmentDisclaimerDialogProps] =
		useState<CustomDisclaimerDialogPropsType>({
			openDialog: false,
			title: "Disclaimer",
			content:
				"Cancer: I hereby apply to Reserve National Insurance Company for insurance coverage to be issued solely and entirely in reliance upon the written answers to the foregoing questions and/or information obtained by the Company in its underwriting process. I agree and understand that no insurance coverage will be in force until the effective date specified by the Company. I represent that no person to be covered under the terms of the certificate being applied for is also covered by Medicaid or any similar program. I have read or had read to me all the questions and answers in this application and such answers to the best of my (our) knowledge and belief are true and complete. I understand and agree that any falsity of any answer or statement in this application which materially affects the acceptance of the risk or hazard assumed by the Company may bar the right to recovery under any certificate issued. FRAUD WARNING: Any person who knowingly presents a false or fraudulent claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.",
			importantTitle: "IMPORTANT",
			importantContent:
				"If an individual is insured under this policy and is also covered by Medicaid or a state variation of Medicaid, most non-disability benefits are automatically assigned according to state regulations.  This means that instead of paying the benefits to the insured individual, we must pay the benefits to Medicaid or the medical provider to reduce the charges billed to Medicaid.  Please consider your circumstances before enrolling in Kemper Benefits coverage.",
			inputFields: [
				{
					name: "Email Discalimer",
					value: emailDisclaimer,
					placeholder: "Enter Email"
				}
			],
			actions: [
				{
					label: "Email Disclaimer",
					callback: () => {
						null;
						// setEnrollmentDisclaimerDialogProps(
						// 	Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
						// );
					}
				}
			]
		});
	const [prevWritingNumber, setPrevWritingNumber] = useState(1408);
	const [showWritingNumberValidateButton, setShowWritingNumberValidateButton] = useState(false);
	const { theme } = useContext(ThemeContext);
	const [standardPremium, setStandardPremium] = useState(0);
	const { paycheck } = useContext(PaycheckContext);
	const { member } = useContext(AuthContext);
	const [eligibleDependents, setEligibleDependents] = useState<Member[]>([]);
	const { setCurrentEnrollment, deleteCurrentEnrollment } = useContext(EnrollmentContext);
	const history = useHistory();
	const { groupOwner } = useContext(GroupOwnerContext);
	const location = useLocation();
	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();
	const [planCode, setPlanCode] = useState<string>();
	const [VEBOpenEnrollmentId, setVEBOpenEnrollmentId] = useState<string>();
	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		VEBPlanName: "Dental"
	});

	const getVEBPlanCode = useCallback((VEBOpenEnrollment: any[]) => {
		// console.log("**********VEBOpenEnrollment********", VEBOpenEnrollment[0]);
		let _planCode, _VEBOpenEnrollmentId;
		for (let idx = 0; idx < VEBOpenEnrollment.length; idx++) {
			const planName = VEBOpenEnrollment[idx].open_enrollment.veb_plan_name;
			const planCode = VEBOpenEnrollment[idx].open_enrollment.veb_plan_code;
			const VEBPlanId = VEBOpenEnrollment[idx].open_enrollment.veb_plan_id;
			const VEBOpenEnrollmentId = VEBOpenEnrollment[idx].VEB_open_enrollment_id;
			// console.log("<====Plan Name===>", planName);

			if (planName === VEB_PLAN_NAMES.dental) {
				_planCode = planCode;
				_VEBOpenEnrollmentId = VEBOpenEnrollmentId;

				const _planPaylaod = {
					_id: VEBPlanId,
					plan_name: planName,
					plan_code: _planCode,
					start_date: null,
					end_date: null,
					status: "ACTIVE"
				};

				setDentalPlan(Object.assign({}, _planPaylaod));
			}
		}

		setPlanCode(_planCode);
		setVEBOpenEnrollmentId(_VEBOpenEnrollmentId);
	}, []);

	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || VEBOpenEnrollment === null) {
			return;
		}
		const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } =
			generateMaxCareDentalWaiveEnrollmentPayload(
				dentalPlan,
				VEB_PLAN_NAME.max_care.dental.standard_dental,
				VEB_PLAN_NAME.max_care.dental.standard_dental,
				null,
				groupOwner,
				member,
				waiveReason,
				VEBOpenEnrollmentId as unknown as string,
				false
			);
		const VEBEnrollmentPayload: VEBEnrollmentPayload = {
			standard_details: VEBEnrollmentStandardDetails,
			common_details: VEBEnrollmentCommonDetails,
			isRider: false
		};
		const response = await trackPromise(api.enrollment.addVEBEnrollment(VEBEnrollmentPayload));
		console.log("RESPONSECEHECKFORVEB---->", response);
		getVEBEnrollmentInitData();
		deleteCurrentEnrollment();
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=2`);
	}, [
		member,
		VEBOpenEnrollment,
		dentalPlan,
		groupOwner,
		waiveReason,
		getVEBEnrollmentInitData,
		deleteCurrentEnrollment,
		urlSearchParams,
		history
	]);

	const handleWaiveButtonClick = useCallback(() => {
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, waiveReason]);

	const handleMacPlanInputChange = (event: SelectChangeEvent) => {
		const { name, value } = event.target as HTMLSelectElement;
		setMacPlanInputs(
			Object.assign({}, macPlanInputs, {
				[name]: value
			})
		);
	};

	const handleWritingNumberChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const { value } = event.target as HTMLInputElement;
			setWritingNumber(Number(value));
			if (Number(value) !== prevWritingNumber) {
				setShowWritingNumberValidateButton(true);
			} else {
				setShowWritingNumberValidateButton(false);
			}
		},
		[prevWritingNumber]
	);

	const waitForModalToClose = () =>
		//eslint-disable-next-line
		new Promise<void>((resolve) => {
			const checkModal = () => {
				if (!isDependentExistsModelOpenRef.current) {
					resolve();
				} else {
					setTimeout(checkModal, 1000);
				}
			};
			checkModal();
		});

	const handleValidation = useCallback((): boolean => {
		const { coverage, benefit_amount } = macPlanInputs;
		if (coverage === null || benefit_amount === null) {
			alert("Please fill all the required field");
			return false;
		}
		if (isActivelyWorking === false) {
			alert("You must actively working 20 hours or more to enroll");
			return false;
		}
		if (hasReadTC === false) {
			alert("Please agree to the Disclaimer");
			return false;
		}
		return true;
	}, [hasReadTC, isActivelyWorking, macPlanInputs]);

	const handleActivateButtonClick = useCallback(async () => {
		const isValid = handleValidation();
		if (isValid === false) {
			return;
		}
		if (member && macPlanInputs.coverage && macPlanInputs.benefit_amount && paycheck && VEBOpenEnrollment) {
			const { VEBEnrollmentCommonDetails, VEBEnrollmentStandardDetails } = generateActivateVEBEnrollmentPayload(
				dentalPlan,
				groupOwner,
				member,
				macPlanInputs.benefit_amount,
				VEB_TO_GENERAL_COVERAGE_CODE[macPlanInputs.coverage as keyof VEBToGeneralCoverageCodeType],
				standardPremium,
				eligibleDependents,
				VEB_PLAN_NAME.max_care.dental.standard_dental,
				standardPremium,
				VEB_PLAN_NAME.max_care.dental.standard_dental,
				null,
				VEBOpenEnrollmentId as unknown as string,
				paycheck,
				writingNumber
			);
			const VEBEnrollmentPayload: VEBEnrollmentPayload = {
				standard_details: VEBEnrollmentStandardDetails,
				common_details: VEBEnrollmentCommonDetails,
				isRider: false
			};
			const existEnrollmentData = await trackPromise(api.enrollment.existsVEBEnrollment(VEBEnrollmentPayload));
			console.log("CHECKINGFORTHEPAYLOAD---->>>>", existEnrollmentData);
			if (Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				setIsDependentExistsModelOpen(true);
				// setExistsDependentData(existEnrollmentData[0].member);
				//eslint-disable-next-line
				setExistsDependentData(existEnrollmentData.map((item) => item.member));
				isDependentExistsModelOpenRef.current = true;
				await waitForModalToClose();
			} else {
				setExistsDependentData(null); // Handle empty case
			}
			if (existEnrollmentData && Array.isArray(existEnrollmentData) && existEnrollmentData.length > 0) {
				const existingSSNs = existEnrollmentData
					//eslint-disable-next-line
					.map((enrollment) => enrollment?.member?.SSN)
					//eslint-disable-next-line
					.filter((ssn) => ssn); // Filter out undefined or null SSNs

				if (existingSSNs.length > 0 && VEBEnrollmentPayload.standard_details) {
					VEBEnrollmentPayload.standard_details = VEBEnrollmentPayload.standard_details.filter(
						(detail: any) => !existingSSNs.includes(detail.member_SSN) && !detail.member_SSN.includes("@")
					);
				}
			}
			if (VEBEnrollmentPayload.standard_details && VEBEnrollmentPayload.standard_details.length === 1) {
				const frequency = paycheck.pay_frequency === "MONTHLY" ? "MONTHLY" : "WEEKLY";
				const benefitAmount = VEBEnrollmentPayload.standard_details[0].benefit_amount.toString();
				const employeeOnlyPremium = macPlan.premium_amount["Employee Only"][benefitAmount]?.[frequency];
				console.log("CHECKINGTHISSHIT", employeeOnlyPremium);
				const totalPremium = employeeOnlyPremium;
				VEBEnrollmentPayload.standard_details[0].premium_amount = totalPremium;
			}
			const response = await api.enrollment.addVEBEnrollment(VEBEnrollmentPayload);
			deleteCurrentEnrollment();
			getVEBEnrollmentInitData();
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=2`);
		}
	}, [
		VEBOpenEnrollment,
		deleteCurrentEnrollment,
		dentalPlan,
		eligibleDependents,
		getVEBEnrollmentInitData,
		groupOwner,
		handleValidation,
		history,
		macPlanInputs.benefit_amount,
		macPlanInputs.coverage,
		member,
		paycheck,
		standardPremium,
		urlSearchParams,
		writingNumber
	]);

	const handleAgreedTCCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setHasReadTC(checked);
	};

	const handleIsActivelyWorkingCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIsActivelyWorking(checked);
	};

	const handleOpenDisclaimerDialogClick = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: true }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleCloseDisclaimerDialog = useCallback(() => {
		setEnrollmentDisclaimerDialogProps(Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false }));
	}, [enrollmentDisclaimerDialogProps]);

	const handleEscapeCloseDisclaimerDialog = useCallback(
		(event: React.KeyboardEvent<HTMLInputElement | HTMLDivElement>) => {
			const Key = event.key;

			if (Key === "Escape")
				setEnrollmentDisclaimerDialogProps(
					Object.assign({}, enrollmentDisclaimerDialogProps, { openDialog: false })
				);
		},
		[enrollmentDisclaimerDialogProps]
	);

	const calculatePremium = useCallback(() => {
		const { coverage, benefit_amount } = macPlanInputs;
		let macPremiumAmount = 0;
		if (coverage && benefit_amount && paycheck) {
			macPremiumAmount =
				macPlan.premium_amount[coverage as keyof MacCoverage][benefit_amount as keyof MacBenefitAmount][
					paycheck.pay_frequency as keyof PaycheckFrequency
				];
			setStandardPremium(macPremiumAmount);
			setCurrentEnrollment(
				Object.assign(
					{},
					{
						plan_name: "Dental",
						status: "Current",
						premium_amount: Number(macPremiumAmount.toFixed(2))
					}
				)
			);
		}
	}, [macPlan.premium_amount, macPlanInputs, paycheck, setCurrentEnrollment]);

	useEffect(() => {
		calculatePremium();
	}, [calculatePremium, macPlanInputs]);
	useEffect(() => {
		isDependentExistsModelOpenRef.current = isDependentExistsModelOpen;
	}, [isDependentExistsModelOpen]);
	useEffect(() => {
		if (dependents) {
			const dependentCoverage = getMaxCareDentailEligibleDependents(dependents);
			console.log("dependentCoverage", dependentCoverage);
			setEligibleDependents(Object.assign([], dependentCoverage.dependents));
			setMacPlan((macPlanDetails: MacPlanDetails) => {
				return Object.assign({}, macPlanDetails, {
					coverage: dependentCoverage.coverage
				});
			});
			setEligiblityDialogProps((prevEligiblityDialogProps: EligiblityDialogProps) => {
				return Object.assign({}, prevEligiblityDialogProps, {
					openDialog: true,
					eligibleDependents: Object.assign([], dependentCoverage.dependents),
					ineligibleRelationshipDependents: Object.assign(
						[],
						dependentCoverage.ineligibleRelationshipDependents
					),
					ineligibleDependents: Object.assign([], dependentCoverage.ineligibleDependents)
				});
			});
		}
	}, [dependents]);

	useEffect(() => {
		if (VEBOpenEnrollment && VEBOpenEnrollment.length !== 0) {
			getVEBPlanCode(VEBOpenEnrollment);
		}
	}, [VEBOpenEnrollment, getVEBPlanCode]);

	return (
		<>
			<div className="kemper-cancer-form plan-form">
				<Suspense fallback={<div />}>
					<CustomEnrollmentDisclaimerDialog
						enrollmentDisclaimerDialogProps={enrollmentDisclaimerDialogProps}
						handleCloseDisclaimerDialog={handleCloseDisclaimerDialog}
						handleEscapeCloseDisclaimerDialog={handleEscapeCloseDisclaimerDialog}
						emailDisclaimer={emailDisclaimer}
						setEmailDisclaimer={setEmailDisclaimer}
					/>
				</Suspense>
				<Suspense fallback={<div />}>
					<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
				</Suspense>
				<Suspense fallback={<div />}>
					{customFormDialogProps ? (
						<LazyCustomFormDialog customFormDialogProps={customFormDialogProps} />
					) : null}
				</Suspense>
				<div className="paper-form-container">
					<Paper className="theme-border-radius paper-container" elevation={1}>
						<VEBPlanHeader
							planName="Max Dental Insurance Policy"
							effectiveDate={
								planCode
									? planCode === "DT-ALL-2024"
										? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
										: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
									: "N/A"
							}
							planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
						/>
						<div className="plan-content">
							<div className="theme-plan-section-margin" />
							<div className="header-container">
								<div className="header-container header-container-new">
									<div className="theme-plan-header">Standard Benefits</div>
								</div>
								<div
									className="theme-plan-sub-header plan-text"
									style={{ borderLeftColor: theme.primary_color }}
								>
									In addition to yourself, who would you like to cover under this plan?
								</div>
							</div>
							<div className="theme-plan-inner-section-margin-2" />
							<Grid className="grid-container" container columnSpacing={2}>
								<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label  required">Coverage For</div>
										<Select
											input={<CustomSelectInput />}
											style={{ width: "100%" }}
											name="coverage"
											onChange={(event: SelectChangeEvent) => handleMacPlanInputChange(event)}
										>
											{macPlan.coverage.map((option: string, index: number) => {
												return (
													<MenuItem value={option} key={index}>
														{option}
													</MenuItem>
												);
											})}
										</Select>
									</div>
								</Grid>
								<Grid item xl={5} lg={5} md={5} sm={5} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label  required">Benefit Amount</div>
										<Select
											input={<CustomSelectInput />}
											style={{ width: "100%" }}
											name="benefit_amount"
											onChange={(event: SelectChangeEvent) => handleMacPlanInputChange(event)}
										>
											<MenuItem value={1500}>1500</MenuItem>
											<MenuItem value={3000}>3000</MenuItem>
											<MenuItem value={5000}>5000</MenuItem>
										</Select>
									</div>
								</Grid>
								<Grid item xl={2} lg={2} md={2} sm={2} xs={6}>
									<div className="details-form-row">
										<div className="details-form-label required align-center">Premium</div>
										<div className="show-premium">{dollarize(standardPremium)}</div>
									</div>
								</Grid>
							</Grid>
						</div>
						<div className="theme-plan-inner-section-margin" />
						<Grid container className="theme-plan-inner-section-margin">
							<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
								<div className="details-form-row">
									<div
										className="details-form-label theme-plan-total-premium align-right"
										style={{ color: theme.primary_color }}
									>
										Total Premium:{" "}
										<span className="show-premium margin-adjust">{dollarize(standardPremium)}</span>
									</div>
								</div>
							</Grid>
						</Grid>
						{!VEBPlanCodes2024.includes(planCode as unknown as string) ? (
							<div className="veb-disclaimer">{/* <VEBDisclaimer /> */}</div>
						) : null}
						<div className="theme-plan-option-content">
							<Checkbox
								checked={isActivelyWorking}
								style={{ paddingLeft: 0 }}
								onChange={handleIsActivelyWorkingCheckboxChange}
							/>
							<p className="theme-plan-checkbox-label">
								<strong>Are you actively at work 20 or more hours per week?</strong>
							</p>
						</div>
						<div>
							<div className="theme-plan-option-content">
								<Checkbox
									checked={hasReadTC}
									style={{ paddingLeft: 0 }}
									onChange={handleAgreedTCCheckboxChange}
								/>
								<p className="theme-plan-checkbox-label">
									<strong>
										I have read the{" "}
										<span
											className="veb-plan-disclaimer"
											style={{ color: theme.primary_color }}
											// onClick={handleOpenDisclaimerDialogClick}
										>
											Disclaimer
										</span>
									</strong>
								</p>
							</div>
						</div>
						{/* <div className="theme-plan-inner-section-margin-2" />
					<Grid container>
						<Grid item xl={4} lg={4} md={4} sm={10} xs={10} columnSpacing={2}>
							<div className="details-form-row">
								<div className="details-form-label required">Writing Number</div>
								<Grid container>
									<Grid item xl={9}>
										<CustomInput value={writingNumber} onChange={handleWritingNumberChange} />
									</Grid>
									{showWritingNumberValidateButton ? (
										<Grid item xl={3}>
											<div className="writing-number-validate-container">
												<Button
													style={{
														backgroundColor: theme.button.background_color,
														color: theme.button.color,
														opacity: 0.8
													}}
												>
													Validate
												</Button>
											</div>
										</Grid>
									) : null}
								</Grid>
							</div>
						</Grid>
					</Grid> */}
						<div className="theme-plan-inner-section-margin-2" />
						<LazyPlanActions
							waiveButtonCallback={handleWaiveButtonClick}
							activateButtonCallback={handleActivateButtonClick}
						/>
					</Paper>
				</div>
			</div>
			{isDependentExistsModelOpen && (
				<ExistsDependentModelVEB
					onClose={() => setIsDependentExistsModelOpen(false)}
					dependentData={existsDependentData}
				/>
			)}
		</>
	);
};

export default MacPlanForm;
